import ServiceBase from "base/baseService"

export default class TabelaCstService extends ServiceBase {

    title = "Tabela de CST"
    pluralTitle = "Tabelas de CST"
    url = '/cadastro/fiscal/tabelacst'
    frontUrl = '/cadastro/fiscal/tabelacst'
    frontUrlList = '/cadastro/fiscal/tabelacstlist'
    primaryKey = 'codigo_tabcst'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable
        data.codigo_tabcst = data?.codigo_tabcst || ''
        data.descricao_tabcst = data?.descricao_tabcst || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}
